import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum LockCodeStatus {
  awaiting = 'awaiting',
  pending = 'pending',
  confirmed = 'confirmed',
}

export default class LockCodeModel extends Model {
  @attr('string') pin!: string;
  @attr('string') status!: LockCodeStatus;

  @belongsTo('booking', {
    inverse: 'lockCode',
    async: false,
  })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'lock-code': LockCodeModel;
  }
}
